<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card elevation="6">
        <div class="pa-3">
          <ReturnTotal total="72"/>
        </div>
        <div class="pa-2">
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="damagedHeaders" :items="damagedList" :search="search" mobile-breakpoint="0">
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.item.refun_lot }}</td>
                <td>{{ dataDetail.item.refun_date }}</td>
                <td>{{ dataDetail.item.refun_total }} {{ dataDetail.item.refun_type }}</td>
                <td>{{ dataDetail.item.supplier }}</td>
                <td><v-btn @click="getDetails(dataDetail.item.id)" class="pa-6 ma-2 grad-success-bg white--text"><v-icon>mdi-file-document-outline</v-icon> จัดทำใบคืนของ</v-btn></td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReturnTotal from "./header_return/ReturnTotal";
export default {
  name: "Return_product",
  components: {
    ReturnTotal
  },
  data() {
    return {
      loading_page: false,
      search: null,
      damagedHeaders: [
        {
          text: 'ล็อตสินค้า',
          value: 'refun_lot',
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'fefun_date',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'refun_total',
          fixed: true,
          width: '160px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: 'supplier',
          fixed: true,
          width: '250px',
        },
        {
          text: '',
          value: 'action',
          fixed: true,
          width: '120px',
        },
      ],
      damagedList: [
        {
          id: 1,
          status_manage: true,
          refun_lot: 'Des65d18',
          refun_date: '12/12/64',
          refun_total: 45,
          refun_type: 'ซอง',
          supplier: 'บริษัท ซิลิค จำกัด',
          status_cn: true
        },
        {
          id: 2,
          status_manage: true,
          refun_lot: 'Des65d18',
          refun_date: '12/12/64',
          refun_total: 45,
          refun_type: 'ซอง',
          supplier: 'บริษัท ซิลิค จำกัด',
          status_cn: true
        },
        {
          id: 3,
          status_manage: false,
          refun_lot: 'Des65d18',
          refun_date: '12/12/64',
          refun_total: 45,
          refun_type: 'ซอง',
          supplier: 'บริษัท ซิลิค จำกัด',
          status_cn: true
        },
        {
          id: 4,
          status_manage: false,
          refun_lot: 'Des65d18',
          refun_date: '12/12/64',
          refun_total: 45,
          refun_type: 'ซอง',
          supplier: 'บริษัท ซิลิค จำกัด',
          status_cn: false
        },
        {
          id: 5,
          status_manage: true,
          refun_lot: 'Des65d18',
          refun_date: '12/12/64',
          refun_total: 45,
          refun_type: 'ซอง',
          supplier: 'บริษัท ซิลิค จำกัด',
          status_cn: true
        },
      ],
    }
  },
  methods: {
    getDetails(id) {
      console.log(id)
    }
  }
}
</script>

<style scoped>

</style>
